import { DropdownItem, HorizontalContainer } from '@american-autonomy/ag-ui';

import CheckmarkIcon from 'components/icons/CheckmarkIcon';
import DropdownText from 'components/text/DropdownText';

import { TEST_ID } from './constants';
import type { Props } from './types';

import styles from './styles.module.scss';

const MapDropdownItem = ({
    children,
    className = '',
    isSelected = false,
    onClick,
    testId = TEST_ID,
    text,
    textClassName = ''
}: Props) => {
    const itemClassName = `${styles.dropdownItem} ${className}`;
    const selectedClassName = isSelected ? styles.selected : '';

    return (
        <DropdownItem
            className={`${itemClassName} ${selectedClassName}`}
            onClick={onClick}
            testId={testId}>
            {text ? (
                <HorizontalContainer className={styles.itemContent}>
                    <DropdownText className={`${styles.itemText} ${textClassName}`} text={text} />

                    {isSelected && <CheckmarkIcon className={styles.checkmark} />}
                </HorizontalContainer>
            ) : (
                children
            )}
        </DropdownItem>
    );
};

export default MapDropdownItem;
